import { render, staticRenderFns } from "./NotificationsPreferences.vue?vue&type=template&id=bdeb361c&scoped=true"
import script from "./NotificationsPreferences.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationsPreferences.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotificationsPreferences.vue?vue&type=style&index=0&id=bdeb361c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdeb361c",
  null
  
)

export default component.exports